/* Practising (not writing practice conversations), and the settings that are only about the person: name, picture, language. */
const DEMO_AVAILABLE_PAGES = ['/settings', '/settings/profile'] as const;

/** Whether a demo organisation's members may use this page; every other one is held back. */
export function availableInDemo(pathname: string): boolean {
  if (pathname === '/practice/new' || pathname.endsWith('/edit')) return false;
  if (pathname === '/practice' || pathname.startsWith('/practice/')) return true;

  return DEMO_AVAILABLE_PAGES.some((page) => pathname === page);
}
